// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_link_date-module__container--2HZeJ"};